module.exports = __webpack_public_path__ + "assets/img/business_en.4a40c387.jpg";